import { enableActivityTracking, disableActivityTracking } from '@snowplow/browser-tracker'
import { useEffect } from 'react'

interface SnowplowActivityTrackingOptions {
  minimumVisitLength?: number
  heartbeatDelay?: number
}

const MIN_MINIMUM_VISIT_LENGTH = 3
const MIN_HEART_BEAT_DELAY = 5

/**
 * https://docs.snowplow.io/docs/collecting-data/collecting-from-own-applications/javascript-trackers/web-tracker/tracking-events/activity-page-pings/
 * This hook is used to enable activity tracking on the page and optionally after waiting on a state to be set.
 * Snowplow will automatically stop sending pagepings if the user stops interacting with the page.
 * Sometimes it will send 1 or 2 more events for good measure once the user has stopped interacting (likely timer based)
 */
export function usePageActivityTracking(options?: SnowplowActivityTrackingOptions) {
  useEffect(() => {
    enableActivityTracking({
      minimumVisitLength: Math.max(options?.minimumVisitLength || MIN_MINIMUM_VISIT_LENGTH, MIN_MINIMUM_VISIT_LENGTH),
      heartbeatDelay: Math.max(options?.heartbeatDelay || MIN_HEART_BEAT_DELAY, MIN_HEART_BEAT_DELAY),
    })
    return () => {
      disableActivityTracking()
    }
  }, []) // oxlint-disable-line react-hooks/exhaustive-deps
}
